import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const KullanimSartlariPage = () => (
  <div className="min-h-screen bg-slate-50">
    <Navbar />
    <div className="pt-16 md:pt-20 bg-slate-900 text-white py-12">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-4xl font-extrabold mb-3">Kullanım Şartları</h1>
        <p className="text-slate-400 text-sm">Son güncelleme: Nisan 2026</p>
      </div>
    </div>
    <div className="max-w-4xl mx-auto px-4 md:px-6 py-14 space-y-8">
      {[
        { title: '1. Kabul', content: 'Bu web sitesini kullanarak aşağıdaki kullanım şartlarını kabul etmiş sayılırsınız. Şartları kabul etmiyorsanız lütfen siteyi kullanmayınız.' },
        { title: '2. Hizmetler', content: 'Sitemiz üzerinden teknik servis randevusu alabilir, ikinci el ürünleri inceleyebilir ve iletişim formu aracılığıyla bizimle iletişime geçebilirsiniz. Ürün fiyatları ve stok bilgileri önceden haber verilmeksizin değiştirilebilir.' },
        { title: '3. Ürün Bilgileri', content: 'Sitede yer alan ikinci el ürün bilgileri, açıklamaları ve fiyatları bilgi amaçlıdır. Kesin fiyat ve stok bilgisi için bizimle doğrudan iletişime geçmenizi öneririz.' },
        { title: '4. Fikri Mülkiyet', content: 'Bu sitedeki tüm içerikler (metin, görsel, logo vb.) firmamıza aittir. İzinsiz kopyalanması, dağıtılması veya kullanılması yasaktır.' },
        { title: '5. Sorumluluk Sınırlaması', content: 'Sitemizin kullanımından doğabilecek doğrudan veya dolaylı zararlardan sorumlu tutulamayız. Site içeriğinin doğruluğu için azami özen gösterilmekle birlikte hata veya eksiklik bulunabilir.' },
        { title: '6. Değişiklikler', content: 'Bu kullanım şartlarını önceden haber vermeksizin değiştirme hakkını saklı tutarız. Güncel şartlar her zaman bu sayfada yayınlanacaktır.' },
        { title: '7. İletişim', content: 'Kullanım şartlarımız hakkında sorularınız için: goldsbilisim06@gmail.com | 0532 541 63 44 | Çevreli Cad. Çaba Sok. No:1/D10, Aydınlıkevler / ANKARA' },
      ].map((section, i) => (
        <div key={i} className="bg-white rounded-xl border border-slate-100 p-6">
          <h2 className="text-lg font-bold text-slate-900 mb-3">{section.title}</h2>
          <p className="text-slate-600 text-sm leading-relaxed">{section.content}</p>
        </div>
      ))}
    </div>
    <Footer />
  </div>
);

export default KullanimSartlariPage;
